import AnimatedText from 'App/Components/AnimatedText';

import playIcon from '../../../../assets/btn-play-icon.svg';
import MainButton from '../../../../components/MainButton';
import polyglot from '../../../../localization';

import './styles.scss';

/**
 * LandingButton component renders a styled button with animated text
 * and a play icon. It supports multiple languages and allows custom
 * styling through optional class names.
 *
 * @param {boolean} disabled — Disables the button when true.
 * @param {string} [btnClassName] — Optional additional CSS class for the button.
 * @param {string} [textClassName] — Optional additional CSS class for the animated text.
 * @param {Function} onClick — Click handler function.
 * @param {'bg' | 'en' | 'es' | 'gr' | 'it' | 'pt' | 'ro' | 'espe' | 'escl' } lang — Language key used to localize the button text.
 * @param {string} alt — Alt text for the play icon image.
 */

export const LandingButton = ({
    disabled,
    btnClassName,
    textClassName,
    alt,
    onClick,
    lang,
    isLightning = false,
}) => {
    return (
        <MainButton
            disabled={disabled}
            className={btnClassName}
            onClick={onClick}>
            <div className='landing-btn_content'>
                <AnimatedText
                    text={
                        isLightning
                            ? polyglot.t(`${lang}.buttonLightning`)
                            : polyglot.t(`${lang}.button`)
                    }
                    className={textClassName}
                />

                <img
                    className='landing-btn_img'
                    src={playIcon}
                    width={20}
                    height={23}
                    alt={alt}
                />
            </div>
        </MainButton>
    );
};
